'use strict';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/map';
import fuse from '../../../_libs/redux-fusion';
import {ReduxListStreamedContainer} from '../../../core-utilities/redux/ReduxListContainer';
import {projectTasksCtrlConfig} from '../../../tasks/router-project-tasks';
import {FILE_REQUIREMENT_COLLECTION} from '../../domain/config';
import {updateProjectFileRequirementRequestModal} from '../../redux/files/updateProjectFileRequirement';
import {componentOptions, reduxList} from '../../redux/fulfillments/projectReqFilesList';
import {RequirementViewFilesContainer} from './RequirementViewFilesContainer';
import {RequirementViewFilesView} from './RequirementViewFilesView';


const StreamedComponent = RequirementViewFilesContainer({
  collection: FILE_REQUIREMENT_COLLECTION,
  taskListState: projectTasksCtrlConfig.taskListState,
  taskDetailsState: projectTasksCtrlConfig.taskDetailsState,
  reduxList,
  updateReduxRequestModal: updateProjectFileRequirementRequestModal,
});

const ListComponent = ReduxListStreamedContainer(
  RequirementViewFilesView,
  reduxList,
  componentOptions,
);
export const ProjectRequirementViewFilesContainer = fuse(StreamedComponent)(ListComponent);



// WEBPACK FOOTER //
// ./src/js/requirements/components/RequirementViewFiles/ProjectRequirementViewFilesContainer.js